import React from 'react'
import { StoredIndividualization } from '../../../../types/Individualization'
import ToggleEye from '../../../../components/ToggleEye'
import IconButton from '../../../../components/IconButton'
import { faCopy, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import styles from './IndividualizationList.module.css'

type IndividualizationListProps = {
    individualizations: StoredIndividualization[]
    toggleVisibility: (individualization_id: number) => void
    deleteIndividualization: (individualization_id: number) => void
    editIndividualization: (individualization_id: number) => void
    copyIndividualization: (individualization_id: number) => void
    demoIndividualization: (individualization_id: number) => void
}

const IndividualizationList: React.FC<IndividualizationListProps> = ({
    individualizations,
    deleteIndividualization,
    editIndividualization,
    copyIndividualization,
    demoIndividualization,
    toggleVisibility,
}) => {
    const { t } = useTranslation(['individualization'])

    return (
        <div className={cx(styles['list-container'])}>
            {individualizations.map((individualization) => (
                <div
                    key={individualization.id}
                    className={cx(
                        styles['list-item'],
                        'zr-d-flex',
                        'zr-justify-between',
                        'zr-items-center'
                    )}
                >
                    <div>
                        {individualization.article ? (
                            <a
                                href={individualization.article.url}
                                target="_blank"
                                rel={'noreferrer'}
                                className={cx(styles['list-title'])}
                                dangerouslySetInnerHTML={{
                                    __html: individualization.article.cName,
                                }}
                            />
                        ) : (
                            <div className={cx(styles['missing-article-hint'])}>
                                {t('overview.articleMissing', {
                                    articleId: individualization.kArtikel,
                                })}
                            </div>
                        )}
                    </div>
                    <div
                        className={cx(styles, 'zr-d-flex', 'zr-items-center')}
                        style={{ gap: '1rem' }}
                    >
                        <div
                            className={cx(
                                styles['list-actions'],
                                'zr-d-flex',
                                'zr-items-center'
                            )}
                        >
                            <IconButton
                                icon={faEdit}
                                color="#2f2f2f"
                                title={t('overview.edit')}
                                onClick={() =>
                                    editIndividualization(individualization.id)
                                }
                            />
                            <IconButton
                                icon={faCopy}
                                color="#2f2f2f"
                                title={t('overview.copy')}
                                onClick={() =>
                                    copyIndividualization(individualization.id)
                                }
                            />
                            <ToggleEye
                                title={
                                    individualization.active
                                        ? t('overview.visibilityActive')
                                        : t('overview.visibilityInactive')
                                }
                                toggleEye={() =>
                                    toggleVisibility(individualization.id)
                                }
                                status={individualization.active}
                                border={false}
                            />
                            <IconButton
                                icon={faTrashAlt}
                                color="#2f2f2f"
                                title={t('overview.delete')}
                                onClick={() =>
                                    deleteIndividualization(
                                        individualization.id
                                    )
                                }
                            />
                        </div>
                        {individualization.article ? (
                            <span
                                onClick={() =>
                                    demoIndividualization(individualization.id)
                                }
                                className={cx(styles['list-demo'])}
                            >
                                {t('overview.demo')}
                            </span>
                        ) : null}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default IndividualizationList
